module.exports = __webpack_public_path__ + "img/82.1442456d.png";